import { Component, EventEmitter, Input, Output } from '@angular/core';

type ApprovalStatus = 'pendiente' | 'aprobado' | 'desaprobado' | string;
type Position = 'bottom-center' | 'bottom-right' | 'top-right' | 'inline';

@Component({
  selector: 'app-botones-estado',
  templateUrl: './botones-estado.component.html',
  styleUrls: ['./botones-estado.component.scss'],
  standalone: false,
})
export class BotonesEstadoComponent {
  private _status: ApprovalStatus = 'pendiente';

  @Input()
  get status(): ApprovalStatus {
    return this._status;
  }
  set status(value: ApprovalStatus) {
    this._status = value ?? 'pendiente';
  }

  @Input() showIfPendingOnly = true;
  @Input() position: Position = 'bottom-center';
  @Input() disabled = false;

  @Input() approveLabel = 'Aprobar';
  @Input() rejectLabel = 'Rechazar';
  @Input() pill = false;
  
  @Input() vertical: boolean | null = null; 

  @Output() approve = new EventEmitter<void>();
  @Output() reject = new EventEmitter<void>();
  @Output() statusChange = new EventEmitter<ApprovalStatus>();
  @Output() approveIntent = new EventEmitter<void>();
  @Output() rejectIntent = new EventEmitter<void>();

  get isVisible(): boolean {
    return this.showIfPendingOnly ? this._status === 'pendiente' : true;
  }

  onApprove() {
    if (this.disabled) return;
    // Solo emitimos intención; el padre decidirá confirmar y luego actualizar status
    this.approveIntent.emit();
  }

  onReject() {
    if (this.disabled) return;
    this.rejectIntent.emit();
  }

  get containerClass(): string {
    switch (this.position) {
      case 'bottom-right':
        return 'approval-actions fixed br';
      case 'top-right':
        return 'approval-actions fixed tr';
      case 'inline':
        return 'approval-actions inline';
      case 'bottom-center':
      default:
        return 'approval-actions fixed bc';
    }
  }

  get isVertical(): boolean {
    return this.vertical === true; // (auto via CSS when null)
  }

  setApprovedExternally() {
    this._status = 'aprobado';
    this.statusChange.emit(this._status);
    this.approve.emit();
  }
  setRejectedExternally() {
    this._status = 'desaprobado';
    this.statusChange.emit(this._status);
    this.reject.emit();
  }
}
